// Pressure relief valve vertex schema
// Safety device (PRV). Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

export const PressureReliefValveVertexSchema = BaseVertexSchema.extend({
  type: z.literal('pressure_relief_valve'),
  elevation: ValueWithUnitSchema,
  set_pressure: ValueWithUnitSchema,
  discharge_coefficient: z.number().optional(),
  discharge_area: ValueWithUnitSchema.optional(),
  back_pressure_correction_factor: z.number().optional(),
});

export type PressureReliefValveVertex = z.infer<typeof PressureReliefValveVertexSchema>;
